import React from 'react';
import { Link } from 'react-router-dom';

const Features = () => {
  return (
    <div className="d-flex flex-column min-vh-100" style={{ background: '#1f2028' }}>
      {/* Navigation Bar */}
      <div style={{ position: 'sticky', top: 0, zIndex: 1000, backgroundColor: '#1f2028', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
        <div className="container-fluid px-3">
          <div className="d-flex align-items-center justify-content-between py-2" style={{ height: '48px' }}>
            {/* Logo/Brand */}
            <div>
              <Link to="/" className="text-decoration-none">
                <h5 className="text-light mb-0 fw-bold" style={{ fontSize: '1.1rem' }}>RE Calc</h5>
              </Link>
            </div>
            
            {/* Navigation Links */}
            <div>
              <Link to="/features" className="btn btn-link text-light text-decoration-none">Features</Link>
              <Link to="/faqs" className="btn btn-link text-light text-decoration-none">FAQs</Link>
              <Link to="/contact" className="btn btn-link text-light text-decoration-none">Get in Touch</Link>
              <Link to="/pricing" className="btn btn-link text-light text-decoration-none">Pricing</Link>
              <Link to="/signup" className="btn btn-primary btn-sm ms-3">Ready to Start?</Link>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="container py-5">
        <h1 className="text-white mb-4">Features</h1>
        
        <div className="row g-4">
          <div className="col-md-6">
            <div className="card bg-dark border-secondary h-100">
              <div className="card-body">
                <h3 className="text-white mb-3">Property Analysis</h3>
                <p className="text-light">
                  Comprehensive property analysis tools that help you evaluate potential investments with key metrics like cap rate, cash-on-cash return, and total ROI.
                </p>
                <ul className="text-light">
                  <li>Purchase price and financing calculations</li>
                  <li>Rental income projections</li>
                  <li>Expense breakdowns and estimates</li>
                  <li>Return metrics and calculations</li>
                </ul>
              </div>
            </div>
          </div>
          
          <div className="col-md-6">
            <div className="card bg-dark border-secondary h-100">
              <div className="card-body">
                <h3 className="text-white mb-3">Scenario Comparison</h3>
                <p className="text-light">
                  Create and compare multiple investment scenarios to find the optimal strategy for each property.
                </p>
                <ul className="text-light">
                  <li>Side-by-side scenario comparison</li>
                  <li>Different financing options</li>
                  <li>Long-term vs. short-term rental analysis</li>
                  <li>Goal-seeking tools to optimize returns</li>
                </ul>
              </div>
            </div>
          </div>
          
          <div className="col-md-6">
            <div className="card bg-dark border-secondary h-100">
              <div className="card-body">
                <h3 className="text-white mb-3">Portfolio Management</h3>
                <p className="text-light">
                  Track and manage your entire real estate portfolio in one place with powerful dashboards and reporting.
                </p>
                <ul className="text-light">
                  <li>Portfolio-wide performance metrics</li>
                  <li>Property comparison tools</li>
                  <li>Cash flow tracking and projections</li>
                  <li>Investment growth visualization</li>
                </ul>
              </div>
            </div>
          </div>
          
          <div className="col-md-6">
            <div className="card bg-dark border-secondary h-100">
              <div className="card-body">
                <h3 className="text-white mb-3">Customizable Settings</h3>
                <p className="text-light">
                  Personalize your analysis with customizable settings that match your investment strategy and goals.
                </p>
                <ul className="text-light">
                  <li>Default target values for key metrics</li>
                  <li>Expense rate presets for different property types</li>
                  <li>Short-term and long-term rental settings</li>
                  <li>Save your preferences for future analyses</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        
        <div className="text-center mt-5">
          <Link to="/signup" className="btn btn-primary btn-lg">Get Started Now</Link>
        </div>
      </div>
      
      {/* Footer */}
      <footer className="py-4 mt-auto" style={{ borderTop: '1px solid rgba(255,255,255,0.1)' }}>
        <div className="container">
          <div className="d-flex justify-content-between align-items-center">
            <p className="text-muted mb-0 small">© 2025 RE Calc. All rights reserved.</p>
            <div>
              <Link to="/login" className="text-muted me-3 small">Login</Link>
              <Link to="/signup" className="text-muted small">Sign Up</Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Features;
